import { combineReducers } from 'redux';
import {
  CREATE_LINE_GROUP,
  DELETE_LINE_GROUP,
  REORDER_LINE_GROUP,
  UPDATE_LINE_GROUP,
  ADD_LINE_TO_LINE_GROUP,
  SELECT_LINE_GROUP_LINE,
  REMOVE_LINE_FROM_LINE_GROUP,
} from '../actions/linegroups';
import { DELETE_LINE } from '../actions/line';

const defaultState = {
  lines: [],
};

function linegroup(state, action) {
  switch (action.type) {
  // case UPDATE_LINE_GROUP: {
  //   return {
  //     ...state,
  //     [action.obj.id]: { ...state[action.obj.id], ...action.obj },
  //   };
  // }
  // case REORDER_LINE_GROUP: {
  //   return {
  //     ...state,
  //     [action.obj.id]: { ...state[action.obj.id], lines: action.lines },
  //   };
  // }

  // case ADD_LINE_TO_LINE_GROUP: {
  //   const newLineGroup = {
  //     ...state[action.lineGroupId],
  //     lines: state[action.lineGroupId].lines.slice(),
  //   };

  //   if (action.index === undefined) {
  //     newLineGroup.lines.push(action.lineId);
  //   } else {
  //     newLineGroup.lines.splice(action.index, 0, action.lineId);
  //   }
  //   return {
  //     ...state,
  //     [action.lineGroupId]: newLineGroup,
  //   };
  // }

  // case DELETE_LINE: {
  //   const newState = {};
  //   for (const lineGroupId of Object.keys(state)) {
  //     newState[lineGroupId] = {
  //       ...state[lineGroupId],
  //       lines: state[lineGroupId].lines.filter(x => x !== action.id),
  //     };
  //   }
  //   return newState;
  // }

  case ADD_LINE_TO_LINE_GROUP: {
    const newLines = [...state.lines];

    if (action.index === undefined) {
      newLines.push(action.lineId);
    } else {
      newLines.splice(action.index, 0, action.lineId);
    }

    return {
      ...state,
      lines: newLines,
    };
  }

  case REMOVE_LINE_FROM_LINE_GROUP: {
    return {
      ...state,
      lines: state.lines.filter((lineId, index) => index !== action.index),
    };
  }

  default:
    return state;
  }
}

export default combineReducers({
  byId: (state = {}, action) => {
    switch (action.type) {
    case SELECT_LINE_GROUP_LINE:
      return {
        ...state,
        [action.id]: linegroup(state[action.id], action),
      };

    case CREATE_LINE_GROUP: {
      return {
        ...state,
        [action.obj.id]: { ...defaultState, ...action.obj },
      };
    }
    case DELETE_LINE_GROUP: {
      const newState = { ...state };
      delete newState[action.id];
      return newState;
    }

    case UPDATE_LINE_GROUP: {
      return {
        ...state,
        [action.obj.id]: { ...state[action.obj.id], ...action.obj },
      };
    }
    case REORDER_LINE_GROUP: {
      return {
        ...state,
        [action.obj.id]: { ...state[action.obj.id], lines: action.lines },
      };
    }

    case ADD_LINE_TO_LINE_GROUP:
    case REMOVE_LINE_FROM_LINE_GROUP:
      return {
        ...state,
        [action.id]: linegroup(state[action.id], action),
      };

    case DELETE_LINE: {
      const newState = {};
      for (const lineGroupId of Object.keys(state)) {
        newState[lineGroupId] = {
          ...state[lineGroupId],
          lines: state[lineGroupId].lines.filter(x => x !== action.id),
        };
      }
      return newState;
    }

    default:
      return state;
    }
  },
  allIds: (state = [], action) => {
    switch (action.type) {
    case CREATE_LINE_GROUP: {
      const newState = [...state];
      if (action.index === undefined) {
        newState.push(action.obj.id);
      } else {
        newState.splice(action.index, 0, action.obj.id);
      }
      return newState;
    }

    default:
      return state;
    }
  },
});

// const sections = (state = { byId: {}, allIds: [] }, action) => {
//   switch (action.type) {
//   case CREATE_SECTION: {
//     return {
//       byId: {
//         ...state.byId,
//         [action.obj.id]: { ...defaultState, ...action.values, id: action.obj.id },
//       },
//       allIds: [...state.allIds, action.obj.id],
//     };
//   }

//   default:
//     return state;
//   }
// };

// export default sections;



// WEBPACK FOOTER //
// ./src/reducers/linegroups.js